import React, { useContext, useState } from 'react'

import Divider from '@components/common/Divider'
import UserContext from '@context/UserContext'

// assets
import bbLogo from '@images/logos/bb-logo-svg.svg'
import fbLogo from '@images/logos/fb.svg'
import googleLogo from '@images/logos/google.svg'

import LoginForm from './Login/Form'
import RegistrationForm from './Registration/Form'
import ForgotPasswordForm from './ForgotPassword/Form'
import ResetPasswordForm from './ResetPassword/Form'

const UserAuth = ({showRegisterForm = false, showCreateNewPasswordForm = false}) => {
	const [showRegister, setShowRegister] = useState(showRegisterForm)
    const [showForgotPassword, setShowForgotPassword] = useState(false)
    const [showCreateNewPassword, setShowCreateNewPassword] = useState(showCreateNewPasswordForm)
	const { setNewlyRegistered } = useContext(UserContext)

	return (
        <React.Fragment>
            <section className="w-full space-y-10">
                <div className="w-full text-center">
                    <img
                        src={bbLogo}
                        className="size-[50px] mx-auto"
                        alt="Blackbough Swim Logo"
                    />
                    <p className="my-4 mx-auto text-[36px] leading-10">
                        {showRegister
                            ? "Join the Blackbough Fam!" 
                            : showForgotPassword ? "Forgot Your Password?"
                            : showCreateNewPassword ? "Create a New Password"
                            : "Log in to unlock exclusive offers and complete your purchase."}
                    </p>
                    <p className="text-[#5D5D5D]">
                        {showRegister
                            ? "Get access to exclusive collections, perks, and more when you register."
                            : showForgotPassword ? "Enter your registered email address and we’ll send you a link to reset your password."
                            : showCreateNewPassword ? "Make sure your new password is strong and secure."
                            : "Enjoy a faster checkout and a personalized shopping experience."
                        }
                    </p>
                </div>
                

                
                {showRegister ? (
                    <RegistrationForm setShowRegister={setShowRegister} />
                ) : showForgotPassword ? (
                    <ForgotPasswordForm />
                ) : showCreateNewPassword ? (
                    <ResetPasswordForm />
                ) : (
                    <LoginForm handleForgotPassword={() => {
                        setShowForgotPassword(true)
                    }} />
                )}

                {
                    /*
                
                        <Divider className="flex items-center justify-center !my-4" text="OR" />

                        <div className="inline-flex md:block md:space-y-4 gap-x-4 items-center w-full justify-center !my-0">
                        <button
                            className="flex md:w-full btn-outline-primary justify-center gap-x-4"
                            alt="Continue with Facebook"
                            onClick={() => {}}
                        >
                            <img src={fbLogo} alt="facebook logo" />
                            <span className="hidden md:block">Continue with Facebook</span>
                        </button>
                        <button
                            className="flex md:w-full btn-outline-primary justify-center gap-x-4"
                            alt="Continue with Google"
                            onClick={() => {}}
                        >
                            <img src={googleLogo} alt="google logo" />
                            <span className="hidden md:block">Continue with Google</span>
                        </button>
                        </div>
                    */
                }

                {!showCreateNewPassword && (
                    <div className="w-full inline-block space-x-4 text-md text-center">
                        <span className="text-[#4F4F4F]">
                            {showRegister
                            ? "Already have an account?"
                            : showForgotPassword ? "Remembered your password?"
                            : "Don't you have an account?"}
                        </span>
                        <button
                            className="underline underline-offset-2 text-black"
                            alt={showRegister ? "Login" : "Register Now"}
                            onClick={() => {
                                setShowForgotPassword(false)
                                setShowRegister(showForgotPassword ? false : !showRegister)
                            }}
                        >
                            {showRegister ? "Login" 
                                : showForgotPassword ? "Go back to Login"
                                : "Register Now"
                            }
                        </button>
                    </div>
                )}
            </section>
        </React.Fragment>
    );
}

export default UserAuth